<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-row>
      <v-col >
        <div class="height: 175px; mb-0" v-if="subredditData">
          <v-img :src="subredditBanner" max-height="200px">
            <div style="width: 100%; background-color: rgba(0,0,0,0.7); position: absolute; bottom: 0" class="pa-3 text-h4">
              <v-avatar size="36">
                <img
                    :src="subredditIcon"
                    alt="John"
                >
              </v-avatar>
              r/{{subredditData.display_name}}</div>
          </v-img>
        </div>
          <v-row>
            <v-col cols="12" md="3"><v-btn block :to="{name: 'subreddit-settings'}" :disabled="!isRegistered">Settings</v-btn></v-col>
            <v-col cols="12" md="3"><v-btn block :to="{name: 'user-whitelist'}" :disabled="!isRegistered">User Whitelist</v-btn></v-col>
            <v-col cols="12" md="3"><v-btn block :to="{name: 'message-templates'}" :disabled="!isRegistered">Message Templates</v-btn></v-col>
            <v-col cols="12" md="3"><v-btn block :to="{name: 'post-history'}" :disabled="!isRegistered">Repost History</v-btn></v-col>
          </v-row>

        <router-view v-on="$listeners" v-on:now-registered="onNowRegistered" ></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {commonRedditCallsMixin} from "@/util/mixins/commonRedditCalls";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
export default {
  name: "Subreddit",
  mixins: [commonRedditCallsMixin],
  data: () => ({
    subredditData: null,
    isLoading: true,
    sleuthConfig: null,
    isRegistered: true,
    crumbs: [
      {text: 'My Subs', disabled: false, href: 'mysubs'},
    ]
  }),
  props: {
    subredditName: String
  },
  methods: {
    onNowRegistered() {
      this.isRegistered = true;
    }
  },
  mounted() {
    if (Object.keys(this.$route.params).length === 0) {
      this.$emit('on-alert', {color: 'error', message: 'No Subreddit Selected'})
      this.$router.push(`/my-subreddits`)
    } else {
      this.loadSubreddits()
        .then(subreddits => {
          console.log('My Subs')
          console.log(subreddits)
        })
      MonitoredSubRepo.getMonitoredSubConfig({params: {token: this.$store.getters.token}}, this.subredditName)
          .then(res => {
            if (res.status === 'error') {
              if (res.data === 'notFound') {
                console.log('Subreddit not found')
                this.isRegistered = false;
                this.$router.push(`/my-subreddits/${this.subredditName}/activate`);
                return
              } else if (res.data === 'unauthorized') {
                console.log('No authorized')
                this.$emit('on-alert', {color: 'error', message: 'You are not authorized to view this Subreddit'})
                this.$router.push(`/my-subreddits`)
              } else {
                console.log('Unknown error')
                this.$emit('on-alert', {color: 'error', message: res.data})
                //this.subredditName = null;
                this.$router.push(`/my-subreddits`)
              }
              return;
            }
            this.getSubreddit(this.subredditName)
                .then(data => {
                  this.subredditData = data;
                  if (this.$route.path.split('/').slice(-1)[0] === 'info') {
                    return;
                  }
                  this.$router.push(`/my-subreddits/${this.subredditName}/info`)

                })
          })

    }
  },
  computed: {
    subredditIcon: function() {
      return this.subredditData.icon_img ? this.subredditData.icon_img : require('../../assets/images/reddit_logo.png')
    },
    subredditBanner: function() {
      return this.subredditData.banner_background_image ? this.subredditData.banner_background_image.split('?')[0] : null
    },
    breadCrumbs () {
      let pathArray = this.$route.path.split('/')
      pathArray.shift()
      const breadCrumbs = []
      breadCrumbs.push({href: '/my-subreddits', disabled: false, text: 'My Subreddits'})
      // needed to handle the intermediary entries for nested vue routes
      let breadcrumb = ''
      let lastIndexFound = 0
      for (let i = 0; i < pathArray.length; ++i) {
        breadcrumb = `${breadcrumb}${'/'}${pathArray[i]}`
        if (this.$route.matched[i] &&
            Object.hasOwnProperty.call(this.$route.matched[i], 'meta') &&
            Object.hasOwnProperty.call(this.$route.matched[i].meta, 'breadCrumb')) {
          let breadCrumbText = this.$route.matched[i].meta.breadCrumb || pathArray[i];
          if (this.$route.matched[i].meta.breadCrumb === 'Subreddit') {
            breadCrumbText = `r/${this.subredditName}`
            breadCrumbs.push({
              href: `/my-subreddits/${this.subredditName}/info`,
              disabled: i + 1 === pathArray.length,
              text: breadCrumbText
            })
            lastIndexFound = i
            breadcrumb = ''
            continue;
          }
          let tempHref = i !== 0 && pathArray[i - (i - lastIndexFound)] ? '/' + pathArray[i - (i - lastIndexFound)] + breadcrumb : breadcrumb
          breadCrumbs.push({
            href: tempHref,
            disabled: i === 1,
            text: breadCrumbText
          })
          lastIndexFound = i
          breadcrumb = ''
        }
      }
      return breadCrumbs
    }
  }
}
</script>

<style scoped>
  .bannerbg {
    background-image: url("https://styles.redditmedia.com/t5_2qjpg/styles/bannerBackgroundImage_b0ojh4ocr2241.png");
    height: 200px;
    width:100%;
  }
</style>
